/**
 *
 * @module hdrType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef HdrType
 * @type {Object}
 * @since 3.8.0
 * @desc Defines the different types of HDR available
 * @example HdrType.hdr10 // 'hdr10'
 *
 * @property {String} dolbyVision - The dolby vision type.
 * @property {String} hdr10 - The Hdr10 type.
 *
 */

/**
 *
 * @enum
 * @type {HdrType}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    dolbyVision: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    hdr10: null
});



// WEBPACK FOOTER //
// ./src/media/hdrType.js